import { render, staticRenderFns } from "./HotelForm.vue?vue&type=template&id=ad72b960&"
import script from "./HotelForm.vue?vue&type=script&lang=js&"
export * from "./HotelForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports